<template>
  <pt-coupon-table class="pt-coupon-table__withData" @couponList="couponList" :table-data="tableData" :total-number="totalNumber" :audit-status="auditStatus" :loading="loading">
  <slot/>
  </pt-coupon-table>
</template>

<script>
import PtCouponTable from './index'
export default {
  name: 'pt-coupon-table__withData',
  components: {
    'pt-coupon-table': PtCouponTable
  },
  props: {
    pageSize: {
      type: Number,
      default: 10
    },
    queryParams: {
      type: Object,
      default: function () {
        return {}
      }
    },
    auditStatus: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      tableData: [],
      totalNumber: 0,
      page_size: this.pageSize,
      loading: false
    }
  },
  watch: {
    queryParams: {
      handler: function (val) {
        this.couponList(0)
      },
      deep: true
    }
  },
  methods: {
    couponList (page, next) {
      let data = {
        ...this.queryParams,
        pageableParam: {
          page: page,
          size: this.page_size,
          sort: 'createdDate,desc'
        }
      }
      if (!next) {
        this.loading = true
      }
      this.$store.dispatch('getCouponsList', data).then(res => {
        this.tableData = res.data
        this.totalNumber = res.totalNumber
        if (next) {
          next(res.data)
        }
        this.loading = false
      }).catch(err => {
        this.loading = false
        this.$message.error(err || '获取优惠劵列表失败')
      })
    }
  }
}
</script>
